import useAppSelector from "~/hooks/use-app-selector.ts";
import { selectUser } from "~/features/user/selectors.ts";
import LoginOrSignUpForm from "~/features/nav/login-or-sign-up-form.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type EmailCollectionStepProps = {
	readonly previouslyCollectedName?: string;
	readonly onGuestLogin: () => void;
};

export default function EmailCollectionStep({
	previouslyCollectedName,
	onGuestLogin,
}: EmailCollectionStepProps) {
	const user = useAppSelector(selectUser);
	const t = useTranslator();

	const isOtpFlow =
		user.type === "waitingForOtp" || user.type === "verifyingOtp";

	return (
		<div className="get-started-step">
			<div className="get-started-content">
				<h1 className="get-started-title">
					{isOtpFlow
						? t("Enter verification code")
						: previouslyCollectedName
							? t("Great to meet you, {previouslyCollectedName}", {
									previouslyCollectedName,
								})
							: t("Great to meet you!")}
				</h1>
				{!isOtpFlow && (
					<p className="get-started-subtitle">
						{t("We'll use your email to save your progress.")}
					</p>
				)}

				<LoginOrSignUpForm
					showJustSignedUpMessage={true}
					finalSubmitLabel={t("Continue")}
					previouslyCollectedName={previouslyCollectedName}
				>
					<div className="guest-option">
						<button
							className="guest-button"
							onClick={onGuestLogin}
							type="button"
						>
							{t("Continue without an account")}
						</button>
					</div>
				</LoginOrSignUpForm>
			</div>
		</div>
	);
}
